import { Adapter as e } from "../../../adapter.js";
import { GoogleAnalyticsPlatformModel as o } from "./googleAnalyticsPlatform.model.js";
class l extends e {
  adapt(t) {
    return new o({
      status: t.status,
      measurementId: t.tag_id
    });
  }
  serialize(t) {
  }
}
export {
  l as GoogleAnalyticsPlatformAdapter
};
//# sourceMappingURL=googleAnalyticsPlatform.adapter.js.map
